
import TableUpdatesRepo from "../utils/repository/tableUpdatesRepo"
import UserRepo from "../utils/repository/userRepo"
import { ROLES } from "../constnats/user"


function usersToMap(users) {
    const userIdToUser = {}
    for (const user of users) {
        userIdToUser[user.id] = user
    }

    return userIdToUser
}

function getUpdatesWithOwners(updates, usersMap) {
    updates = JSON.parse(JSON.stringify(updates))
    for (const update of updates) {
        update.owner = usersMap[update.ownerId]

        for (const review of update.reviews) {
            review.owner = usersMap[review.ownerId]
        }
    }
    return updates
}

function getUpdates(searchSpec) {
    return new Promise((resolve, reject) => {
        TableUpdatesRepo.find(searchSpec, resolve)
    })
}

export function getReviewsByUpdateIds(updateIds) {
    return new Promise((resolve, reject) => {
        if (updateIds.length === 0) {
            resolve([])
            return
        }
        TableUpdatesRepo.listReviews(updateIds, resolve, reject)
    })
}

export function getUpdateWithReviewsAndOwners(updateId) {
    const updateRes = new Promise((resolve, reject) => TableUpdatesRepo.get(updateId, resolve, reject))
    return Promise.all([updateRes, getReviewsByUpdateIds([updateId]), getUsers()])
        .then(([update, reviews, usersMap]) => ({
            ...update,
            owner: usersMap[update.ownerId],
            reviews: reviews.map(r => ({ ...r, owner: usersMap[r.ownerId] })),
        }))
}

function attachReviews(updates, reviews) {
    const reviewsByUpdateId = {}
    for (const review of reviews) {
        if (!reviewsByUpdateId[review.updateId]) {
            reviewsByUpdateId[review.updateId] = []
        }
        reviewsByUpdateId[review.updateId].push(review)
    }

    for (const update of updates) {
        update.reviews = reviewsByUpdateId[update.id] || []
    }
}

function getUsers() {
    return new Promise((resolve, reject) => {
        UserRepo.list({ userRoles: [ROLES.EMPLOYEE], includeDisabled: true }, users => {
            resolve(usersToMap(users))
        }, reject)
    })
}

function enrichUpdates(response, usersMap) {
    const updates = response.data.content
    return getReviewsByUpdateIds(updates.map(u => u.id)).then(reviews => {
        attachReviews(updates, reviews)
        const enrichedUpdates = usersMap ? getUpdatesWithOwners(updates, usersMap) : updates
        return {
            ...response,
            data: {
                ...response.data,
                content: enrichedUpdates,
            },
        }
    })
}

class TableUpdates {

    static find(searchSpec, includeOwners = true) {
        const updatesRes = getUpdates(searchSpec)

        if (includeOwners) {
            const usersRes = getUsers()
            return Promise.all([updatesRes, usersRes])
                .then(([response, usersMap]) => enrichUpdates(response, usersMap))
        } else {
            return updatesRes.then(response => enrichUpdates(response, null))
        }
    }
}

export default TableUpdates
